import { useNavigate } from 'react-router-dom';
import { pb } from '@/core/api';
import { useAuthStore } from '@/stores/auth';
import { useSignup } from './use-registration-api';
import { useRegistrationFlow } from './use-registration-flow';
import { useSignupSubmit } from './use-signup-submit';
import { type FormState, useFormState } from './use-form-state';

type PageState = FormState & {
  pending: boolean;
  onSubmit: () => void;
};

export function useSignupPage(): PageState {
  const nav = useNavigate();
  const s = useFormState();
  const signup = useSignup();
  const { getSessionToken, clearSession } = useRegistrationFlow();
  const refreshAuth = useAuthStore((st) => st.refreshAuth);
  const { handleSubmit } = useSignupSubmit({
    ...s,
    signup,
    getSessionToken,
    clearSession,
    navigate: nav,
    pb,
    refreshAuth,
  });
  return {
    ...s,
    pending: signup.isPending,
    onSubmit: () => void handleSubmit(),
  };
}
